import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { USER, URL } from "../../constants/constant";
import { PHLEBO_PG_INCENTIVE_SLABS } from "../../constants/phleboIncentiveSlabs";
import "./LeaderboardProgressHub.css";
import PhleboLeaderboard from "./leaderboard";
import SelfInfoDashboard from "./MyProgressHub";

const LeaderboardProgressHub = () => {
	const history = useHistory();
	const location = useLocation();
	const [activeTab, setActiveTab] = useState("leaderboard");

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const tab = params.get("tab");
		if (tab === "progress") {
			setActiveTab("progress");
		} else {
			setActiveTab("leaderboard");
		}
	}, [location.search]);

	const handleTabChange = (tab) => {
		setActiveTab(tab);
		history.push(`/leaderboardProgressHub?tab=${tab}`);
	};

	const handleBack = () => {
		history.goBack();
	};

	const getCurrentMonth = () => {
		const months = [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December",
		];
		const currentDate = new Date();
		return `${months[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
	};

	return (
		<div className="leaderboard-progress-hub-container">
			<header className="hub-header">
				<nav className="navbar navbar-dark bg-primary">
					<button className="back-button" onClick={handleBack}>
						<i className="fa fa-arrow-left"></i>
					</button>
					<div className="navbar-brand">
						<h2 className="hub-title">
							{activeTab === "leaderboard" ? "Phlebo Leaderboard" : "My Progress Hub"}
						</h2>
					</div>
				</nav>
			</header>

			<div className="tabs-container">
				<div className="tabs-wrapper">
					<button
						className={`tab-button ${activeTab === "leaderboard" ? "active" : ""}`}
						onClick={() => handleTabChange("leaderboard")}
					>
						Leaderboard
					</button>
					<button
						className={`tab-button ${activeTab === "progress" ? "active" : ""}`}
						onClick={() => handleTabChange("progress")}
					>
						My Progress Hub
					</button>
				</div>
			</div>

			<div className="tab-content">
				{activeTab === "leaderboard" ? (
					<PhleboLeaderboard isEmbedded={true} />
				) : (
					<SelfInfoDashboard isEmbedded={true} />
				)}
			</div>
		</div>
	);
};

export default LeaderboardProgressHub;
